module.exports = __webpack_public_path__ + "img/homePageConfigure.0db2c510.svg";